import { GraphQLTestTarget } from "../services/api";
import { TestTarget, TestTargetFormData } from "../types/TestTarget";

export const parseParamsSafe = (rawParams?: string) => {
  if (!rawParams) {
    return {};
  }
  try {
    return JSON.parse(rawParams);
  } catch (error) {
    console.warn(
      "NOTE: TestTarget paramsのパースに失敗したため空オブジェクトを使用します。",
      error
    );
    return {};
  }
};

export const toCreatedTestTarget = (
  created: GraphQLTestTarget,
  source: TestTargetFormData
): TestTarget => ({
  id: created.testTargetId,
  test_target_id: created.testTargetId,
  name: created.name,
  type: source.type,
  description: created.description || "",
  displayOrder: created.displayOrder ?? source.displayOrder ?? 0,
  parentId: created.parentTestTargetId,
  parent_test_target_id: created.parentTestTargetId,
  params: parseParamsSafe(created.params),
  metaInfo: {
    createdAt: new Date().toISOString(),
    createdBy: "user",
    modifiedAt: new Date().toISOString(),
    modifiedBy: "user",
  },
});

